import type { SupportLink } from '@cash-web/protos/squareup/cash/supportarticles/app/v1beta1/support_link.pb'

import { MAX_DISPLAYED_RESULTS } from './constants'
import type { SearchDocumentResult, SearchResponse, SearchResult } from './types'

export function toHelpResult(document_result: SearchDocumentResult): SearchResult {
  return {
    document_id: document_result.document.document_id,
    title: document_result.document.title,
    preview:
      document_result.document.fields.find(field => field.name === 'body')?.value?.replaceAll(/\\\\?([-&])/g, '$1') ??
      '', // Yext via bookshelf escapes dashes and ampersands
    url: document_result.document.url,
  }
}

const getUrl = (supportLink: SupportLink) => {
  if (supportLink.url) {
    return supportLink.url
  }

  if (supportLink.articleToken) {
    return `/support/${supportLink.articleToken}`
  }

  // TODO janec figure out how to handle client scenarios and client routes
  return null
}

export function toSupportResult(supportLink: SupportLink): SearchResult | null {
  const url = getUrl(supportLink)

  if (url) {
    return {
      document_id: supportLink.articleToken ?? '',
      title: supportLink.titleText ?? '',
      preview: supportLink.previewText ? supportLink.previewText.replaceAll(/\\\\?([-&])/g, '$1') + '…' : '',
      url,
    }
  }

  return null
}

export const toSearchArticleResults = (data: SearchResponse) => ({
  results: data.document_results?.map(toHelpResult) ?? [],
  total_result_count: data.total_result_count ?? 0,
  error_message: data.error_message ?? '',
})

export const toSearchArticleResultsForSupportLinks = (data: SupportLink[]) => {
  const result = data?.map(toSupportResult).filter(Boolean) as SearchResult[]
  return {
    results: result,
    previewResults: result.slice(0, MAX_DISPLAYED_RESULTS),
    total_result_count: result.length ?? 0,
    error_message: '', // TODO janec handle error message
  }
}
